// extracted by mini-css-extract-plugin
export default {"premium-folder-icon":"_1UC3D","premiumFolderIcon":"_1UC3D"};